import { render } from "./AttributeRanges.vue?vue&type=template&id=2b2f6166"
import script from "./AttributeRanges.vue?vue&type=script&lang=js"
export * from "./AttributeRanges.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/quality_inspect.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquality_control%2Fquery_container%2Fshow_inspect%2FAttributeRanges.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/views/packing_house/quality_control/process/show_inspect/quality_group_details.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fcustomer%2Fquality_control%2Fquery_container%2Fshow_inspect%2FAttributeRanges.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__